import React from "react"
import { useCallStore } from "../../stores"
import { NotSetupState } from "./states/NotSetupState"
import { IdleState } from "./states/IdleState"
import { IncomingState } from "./states/IncomingState"
import { OnCallState } from "./states/OnCallState"
import { ErrorState } from "./states/ErrorState"

interface AgentCommandCenterProps {
  collapsed?: boolean
}

export function AgentCommandCenter({ collapsed }: AgentCommandCenterProps) {
  const { browserDialing, incomingCall, currentCall } = useCallStore()

  // Determine which state to show based on call center state
  const needsSetup =
    browserDialing === "not_setup" || browserDialing === "loading"
  const hasError = browserDialing === "error"
  const hasIncomingCall = !!incomingCall?.call_sid
  const hasCurrentCall = currentCall !== null

  // Render the appropriate state component
  if (hasError) {
    return <ErrorState collapsed={collapsed} />
  }

  if (needsSetup) {
    return <NotSetupState collapsed={collapsed} />
  }

  if (hasCurrentCall) {
    return <OnCallState collapsed={collapsed} />
  }

  if (hasIncomingCall) {
    return <IncomingState collapsed={collapsed} />
  }

  // Default: Ready/Idle state
  return <IdleState collapsed={collapsed} />
}

// Export all components for direct use if needed
export { AgentAvatar } from "./AgentAvatar"
export { NotSetupState } from "./states/NotSetupState"
export { IdleState } from "./states/IdleState"
export { IncomingState } from "./states/IncomingState"
export { OnCallState } from "./states/OnCallState"
export { ErrorState } from "./states/ErrorState"
export { CallControls } from "./controls/CallControls"
export { DTMFKeypad } from "./controls/DTMFKeypad"
